import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { signupUser } from '../Common/auth';
import { toast } from 'react-toastify';
import Loader from '../Components/Loader/Loader';

function SignUp() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Email: "",
    Name: "",
    Number: "",
    Password: ""
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: false
    }));
  };
  const validateForm = () => {
    const { Email, Name, Number, Password } = formData;
    let newErrors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!Email || !emailRegex.test(Email)) newErrors.Email = true;
    if (!Name || Name.length < 3) newErrors.Name = true;
    if (!Number || !phoneRegex.test(Number)) newErrors.Number = true;
    if (!Password || Password.length < 6) newErrors.Password = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await signupUser(formData);
      toast.success("Signup Successful!");
      setFormData({ Email: "", Name: "", Number: "", Password: "" });
      navigate("/sign-in");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Signup failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <section className='sign-up pt-[80px]'>
        <div className='pt-[54px] lg:pr-[154px] pr-[20px] lg:pb-[154px] pb-[50px] lg:pl-[68px] pl-[20px] flex lg:flex-row flex-col items-center gap-[20px]'>
          <div>
            <img src="/assets/profile/img3.png" alt="" />
          </div>
          <div className='max-w-[539px] mx-auto w-full lg:rounded-[40px] rounded-[20px] lg:p-[44px] p-[22px]' style={{ boxShadow: "0px 4px 35px 0px #00000014" }}>
            <div className="flex justify-between lg:flex-row flex-col items-start">
              <h6 className="font-[400] font-poppins text-[21px] text-[#000000]">Welcome to <span className='font-[700] text-[#FF6000]'>Narsingh Temple</span></h6>
              <p className="font-[400] text-[13px] font-poppins text-[#8D8D8D]">Have an Account ?<br />
                <Link to="/sign-in" className='text-[#F68B29]'>Sign in</Link></p>
            </div>
            <h6 className="font-[500] font-poppins md:text-[55px] text-[30px] text-[#000000] lg:pb-[50px] pb-[20px]">Sign Up</h6>
            <div className='grid grid-cols-1 lg:gap-[35px] gap-[20px]'>
              <div className='flex flex-col gap-[13px]'>
                <p className="font-[400] font-poppins text-[16px] text-[#000000]">Enter your username or email address</p>
                <input
                  type="email"
                  value={formData.Email}
                  onChange={handleChange}
                  name='Email'
                  className={`border-[#ADADAD] border bg-[#FFFFFF] rounded-[9px] py-[19px] px-[25px] font-[300] font-poppins text-[14px] text-[#808080] ${errors.Email ? 'border-red-500' : ''}`}
                  placeholder='Username or email address' />
              </div>
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-[20px]">
                <div className='flex flex-col gap-[13px]'>
                  <p className="font-[400] font-poppins text-[16px] text-[#000000]">User Name</p>
                  <input type="text"
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                    className={`border-[#ADADAD] border bg-[#FFFFFF] rounded-[9px] py-[19px] px-[25px] font-[300] font-poppins text-[14px] text-[#808080] ${errors.Name ? 'border-red-500' : ''}`}
                    placeholder='User name' />
                </div>
                <div className='flex flex-col gap-[13px]'>
                  <p className="font-[400] font-poppins text-[16px] text-[#000000]">Contact Number</p>
                  <input
                    type="text"
                    name="Number"
                    value={formData.Number}
                    onChange={(e) => {
                      const onlyNums = e.target.value.replace(/[^0-9]/g, ''); // remove non-numeric chars
                      if (onlyNums.length <= 10) {
                        handleChange({ target: { name: 'Number', value: onlyNums } });
                      }
                    }}
                    className={`border-[#ADADAD] border bg-[#FFFFFF] rounded-[9px] py-[19px] px-[25px] font-[300] font-poppins text-[14px] text-[#808080] ${errors.Number ? 'border-red-500' : ''}`}
                    maxLength="10"
                    placeholder='Contact Number' />
                </div>
              </div>
              <div className='flex flex-col gap-[13px]'>
                <p className="font-[400] font-poppins text-[16px] text-[#000000]">Enter your Password</p>
                <input
                  type={showPassword ? "text" : "password"}
                  name="Password"
                  value={formData.Password}
                  onChange={handleChange}
                  className={`border-[#ADADAD] border bg-[#FFFFFF] rounded-[9px] py-[19px] px-[25px] font-[300] font-poppins text-[14px] text-[#808080] ${errors.Password ? 'border-red-500' : ''}`}
                  placeholder='Password'
                />
              </div>
              <button onClick={handleSubmit} style={{ background: "linear-gradient(90deg, #FF6000 0%, #F68B29 100%)" }} className='py-[15px] w-full rounded-[10px] font-poppins font-[500] text-[16px] cursor-pointer text-[#FFFFFF]'>Sign up</button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SignUp